import React from 'react';
// Toasts removed
import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import Layout from 'components/common/Layout/Layout';

import { AuthProvider } from 'context/AuthContext';
import ProtectedRoute from 'Views/ProtectedRoute';
import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';
import UserFriendlyErrorBoundary from 'components/common/UserFriendlyErrorBoundary/UserFriendlyErrorBoundary';
import GlobalErrorHandler from 'components/common/GlobalErrorHandler/GlobalErrorHandler';
import NotFound from 'components/common/ErrorBoundary/NotFound';
import UserFriendlyNotFound from 'components/common/UserFriendlyNotFound/UserFriendlyNotFound';
import UserFriendlyLoading from 'components/common/UserFriendlyLoading/UserFriendlyLoading';
import { ROUTES } from 'constants/routes';
import ForgotPassword from 'Views/ForgotPassword/ForgotPassword';
import ResetPassword from 'Views/ResetPassword/ResetPassword';
import DebugControls from './Utils/DebugControls';
const Home = lazy(() => import('Views/Home/Home'));
const Login = lazy(() => import('Views/Login/Login'));
const Register = lazy(() => import('Views/Register/Register'));
const Submissions = lazy(() => import('Views/Submissions/Submissions'));
const Dashboard = lazy(() => import('Views/Dashboard/Dashboard'));
const Agencies = lazy(() => import('Views/Agency/Agencies'));
const Agents = lazy(() => import('Views/Agents/Agents'));
const AddAgent = lazy(() => import('Views/Agents/AddAgent'));
const AddAgency = lazy(() => import('Views/Agency/AddAgency'));
const Admins = lazy(() => import('Views/Admins/Admins'));
const AddAdmin = lazy(() => import('Views/Admins/AddAdmin'));
const Clients = lazy(() => import('Views/Clients/Clients'));
const AddClient = lazy(() => import('Views/Clients/AddClient'));
const Resources = lazy(() => import('Views/Resources/Resources'));
const Application = lazy(() => import('Views/Application/Application'));
const Profile = lazy(() => import('Views/Profile/Profile'));
const Account = lazy(() => import('Views/Account/Account'));
const Settings = lazy(() => import('Views/Settings/Settings'));


function App() {
    return (
        <Router>
            <AuthProvider> 
                <GlobalErrorHandler>
                <UserFriendlyErrorBoundary>
                <ErrorBoundary>
                <Suspense fallback={<UserFriendlyLoading />}>
                <Routes>
                    {/* Public Routes - Full screen without layout */}
                    <Route path={ROUTES.login} element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgotPassword" element={<ForgotPassword />} />
                    <Route path="/resetPassword" element={<ResetPassword />} />
                    <Route path={ROUTES.root} element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                        <Route index element={<Home />} />
                        <Route path="submissions" element={< Submissions />} />
                        <Route path="dashboard" element={< Dashboard />} />
                        <Route path="agencies" element={< Agencies />} />
                        <Route path="agencies/add" element={< AddAgency />} />
                        <Route path="agents" element={< Agents />} />
                        <Route path="agents/add" element={< AddAgent />} />
                        <Route path="admins" element={< Admins />} />
                        <Route path="admins/add" element={< AddAdmin />} />
                        <Route path="clients" element={< Clients />} />
                        <Route path="clients/add" element={< AddClient />} />
                        <Route path="resources" element={< Resources />} />
                        <Route path="application" element={< Application />} />
                        <Route path="profile" element={< Profile />} />
                        <Route path="account" element={< Account />} />
                        <Route path="settings" element={< Settings />} />
                        {/* <Route path="/dashboard" element={< Dashboard />} /> */}
                    </Route>
                    <Route path={ROUTES.notFound} element={<UserFriendlyNotFound />} />
                    <Route path="*" element={<UserFriendlyNotFound />} />
                </Routes>
                </Suspense>
                </ErrorBoundary>
                </UserFriendlyErrorBoundary>
                </GlobalErrorHandler>
                
                {/* Debug Controls - Only shown in development */}
                <DebugControls />
                
                {null}
            </AuthProvider>
        </Router>
    );
}

export default App;
